import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard'; // This will now resolve to /manage/src/pages/Dashboard.js
import PendingApprovals from './pages/PendingApprovals';
import Bookkeepers from './pages/Bookkeepers';
import BookkeepersByZipcode from './pages/BookkeepersByZipcode';
import Zipcodes from './pages/Zipcodes';
import ExpirationManagement from './pages/ExpirationManagement';
import Analytics from './pages/Analytics';
import AdminUsers from './pages/AdminUsers';
import BookkeeperDetail from './pages/BookkeeperDetail';
import BookkeeperEdit from './pages/BookkeeperEdit';
import './styles/App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              {/* Add the shorter routes that the sidebar expects */}
              <Route path="/pending" element={
                <ProtectedRoute>
                  <Layout>
                    <PendingApprovals />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/pending-approvals" element={
                <ProtectedRoute>
                  <Layout>
                    <PendingApprovals />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/bookkeepers" element={
                <ProtectedRoute>
                  <Layout>
                    <Bookkeepers />
                  </Layout>
                </ProtectedRoute>
              } />
              {/* FIXED: Add the correct route for bookkeepers by zipcode */}
              <Route path="/bookkeepers-by-zipcode/:zipCode" element={
                <ProtectedRoute>
                  <Layout>
                    <BookkeepersByZipcode />
                  </Layout>
                </ProtectedRoute>
              } />
              {/* Keep the old route for compatibility */}
              <Route path="/bookkeepers/zipcode/:zipcode" element={
                <ProtectedRoute>
                  <Layout>
                    <BookkeepersByZipcode />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/zipcodes" element={
                <ProtectedRoute>
                  <Layout>
                    <Zipcodes />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/expiration" element={
                <ProtectedRoute>
                  <Layout>
                    <ExpirationManagement />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/expiration-management" element={
                <ProtectedRoute>
                  <Layout>
                    <ExpirationManagement />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/analytics" element={
                <ProtectedRoute>
                  <Layout>
                    <Analytics />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/admin-users" element={
                <ProtectedRoute>
                  <Layout>
                    <AdminUsers />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/bookkeepers/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <BookkeeperDetail />
                  </Layout>
                </ProtectedRoute>
              } />
              {/* ADD THE EDIT ROUTE */}
              <Route path="/bookkeepers/:id/edit" element={
                <ProtectedRoute>
                  <Layout>
                    <BookkeeperEdit />
                  </Layout>
                </ProtectedRoute>
              } />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;